import React from 'react';
import { useAnalytics } from '../../../../../../../common/AnalyticsContext/useAnalytics';
import { SearchResultPractice } from '../../../../../../types';
import { Rating } from '../../Rating/Rating';
import { Wrapper } from './PracticeDetails.styles';

interface Props {
  practice: SearchResultPractice;
}

export const PracticeDetails = ({ practice }: Props) => {
  const { preferredProviders: unFilteredProviders, interests: unfilteredInterests } = practice;

  const preferredProviders = unFilteredProviders || [];
  const interests = unfilteredInterests || [];

  const hasInterests = interests.length !== 0;

  const hasPreferredProviders = preferredProviders.length !== 0;

  useAnalytics({
    resultsData: {
      // we leave it as undefined to let other cards potentially override it
      hasInterests: hasInterests ? true : undefined,
      hasPreferredProvider: hasPreferredProviders ? true : undefined,
    },
  });

  return (
    <Wrapper>
      <Rating rating={practice.rating} />
    </Wrapper>
  );
};
